import Layout from '../../features/Layout';
import Privacy from '../../components/Privacy';

const PrivacyPage = ({ isProd }: { isProd: boolean }) => {
  return (
    <Layout
      title="Khatabook - Privacy Policy"
      description="Read the Privacy Policy for using Khatabook. Digital India's Digital Khata!"
      isProd={isProd}
    >
      <Privacy />
    </Layout>
  );
};

export default PrivacyPage;
